import { environment } from '../../environments/environment';
import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

const requestOptions = { headers: { 'Content-Type': 'application/json' } };
@Injectable()
export class EngagementManagementService {

  constructor(private http: HttpClient) {
  }
  addEngagement(engagementDetails): Observable<any> {
    return this.http.post(environment.APIEndpoint + 'api/Engagement/SaveEngagement', engagementDetails)
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  getEngagementRoles(languageIds: number[]): Observable<any> {
    return this.http.post(environment.APIEndpoint + 'api/Engagement/GetEngagementRoles', languageIds)
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  findShortUrl(shortUrl): any {
    return this.http.get(environment.APIEndpoint + 'api/Engagement/FindShortUrl?shortUrl=' + shortUrl)
      .pipe(map((data: boolean) => {
        if (data)
          return { 'shortUrlExits': "Short url already exist's" }
        else
          return null;
      }),
        catchError(this.handleError));
  }

  getEngagementBasicDetails(engagementId: number): Observable<any> {
    return this.http.get(environment.APIEndpoint + 'api/Engagement/GetEngagementBasicDetails?engagementId=' + engagementId)
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  getEngagementDetails(engagementId: number): Observable<any> {
    return this.http.get(environment.APIEndpoint + 'api/Engagement/GetEngagementDetails?engagementId=' + engagementId)
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  GetEngagementsForExternalUser(engagementId: number, languageId: number): Observable<any> {
    return this.http.get(environment.APIEndpoint + 'api/Engagement/FetchEngagementForExternalurl?engagementId=' + engagementId + '&&' + 'languageId=' + languageId)
      .map((res) => res)
      .catch(this.handleError);
  }


  updateEngagement(engagementDetails): Observable<any> {
    return this.http.post(environment.APIEndpoint + 'api/Engagement/UpdateEngagement', engagementDetails)
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  getContactInternalInfoList(EngagementId: number, languageId: number): Observable<any> {

    return this.http.get(environment.APIEndpoint + 'api/Engagement/FetchContactInternelInfoList?engagementId=' + EngagementId + '&&' + 'languageId=' + languageId)
      .pipe(map((data) => data),
        catchError(this.handleError));

  }

  getContactExternalInfoList(EngagementId: number, languageId: number): Observable<any> {

    return this.http.get(environment.APIEndpoint + 'api/Engagement/FetchContactExternelInfoList?engagementId=' + EngagementId + '&&' + 'languageId=' + languageId)
      .pipe(map((data) => data),
        catchError(this.handleError));

  }

  validateEngagementName(engagementName: string, engagementId: number) {
    return this.http.get(environment.APIEndpoint + 'api/Engagement/FindEngagementName?engagementName=' + engagementName + '&engagementId=' + engagementId)
      .pipe(map((data: boolean) => {
        if (data)
          return { 'engagementNameExist': "Engagement name already exists" }
        else
          return null;
      }),
        catchError(this.handleError));
  }

  updateEngagementStatus(engagementModel: any): Observable<any> {
    return this.http.post(environment.APIEndpoint + 'api/Engagement/UpdateEngagementStatus', engagementModel)
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  updateEngagementBasicInfo(engagementBasicInfoModel): Observable<any> {
    return this.http.post(environment.APIEndpoint + 'api/Engagement/UpdateEngagementDetails', engagementBasicInfoModel)
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  addEngagementDetails(engagementDetailsModel: any): Observable<any> {
    return this.http.post(environment.APIEndpoint + 'api/Engagement/AddEngagementDetails', engagementDetailsModel)
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  getSaveEngagementDraft(engagementDetailsId: number): Observable<any> {
    return this.http.get(environment.APIEndpoint + 'api/Engagement/GetSavedEngagementDraft?engagementDetailsId=' + engagementDetailsId)
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  approveEngagementDetails(engagementId: number, engagementDetailsId: number): Observable<any> {
    return this.http.post(environment.APIEndpoint + 'api/Engagement/ApproveEngagementDetails?engagementId=' + engagementId + "&engagementDetailsId=" + engagementDetailsId, null)
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  addorupdateEngagementDetails(engagementDetailsHitoryModel: any): Observable<any> {
    return this.http.post(environment.APIEndpoint + 'api/Engagement/SaveOrUpdateDraft', engagementDetailsHitoryModel, { headers: new HttpHeaders().set("Content-Type", "application/json") })
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  deleteEngagement(engagementId: number): Observable<any> {
    return this.http.delete(environment.APIEndpoint + 'api/Engagement/DeleteEngagement?engagementId=' + engagementId)
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  sendForApproval(engagementDetailsHistoryId: number, userId): Observable<any> {
    return this.http.get(environment.APIEndpoint + 'api/Engagement/SendForApproval?engagementDetailsHistoryId=' + engagementDetailsHistoryId + "&userId=" + userId)
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  getEngagementAwaitingApprovals(engagementId: number): Observable<any> {
    return this.http.get(environment.APIEndpoint + 'api/Engagement/GetEngagementDetailsForApproval?engagementId=' + engagementId)
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  getIsEngagementDetailsApproved(engagementId: number): Observable<any> {
    return this.http.get(environment.APIEndpoint + 'api/Engagement/GetIsEngagementDetailsApproved?engagementId=' + engagementId)
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  getEngagementDetailsHistory(engagementDetailsId: number): Observable<any> {
    return this.http.get(environment.APIEndpoint + 'api/Engagement/GetEngagementDetailsHistoryLog?engagementDetailsId=' + engagementDetailsId)
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  getApprovalManagementEngagementApprovals(isAllView: boolean): Observable<any> {
    return this.http.get(environment.APIEndpoint + 'api/Engagement/GetEngagementAwaitingApprovals?isAllView=' + isAllView)
      .pipe(map((data) => data),
        catchError(this.handleError));
  }

  getEngagementStatusLog(engagementId: number, languageId: number):Observable<any> {
    return this.http.get(environment.APIEndpoint + 'api/Engagement/GetEngagementStatusLog?engagementId=' + engagementId + '&languageId=' + languageId).pipe(map((data) => data),
      catchError(this.handleError));
  }

  private handleError(error: Response) {
    console.error(error);
    return throwError(error || 'Server error');
  }


}
